import { Methods } from '@api/follow/add'
import { Request } from '../../request'
export default async (query:Methods["get"]["query"]) => Request( client => client.follow.add.$get({query}) )
